/**
 * plugins/webfontloader.ts
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */
// eslint-disable-next-line
import webFontLoader from 'webfontloader';

export function loadFonts() {
  webFontLoader.load({
    google: {
      families: ['Open+Sans:300,300i,400,400i,500,500i,600,600i,700,700i,800,800i&display=swap'],
    },
  });
}
